import { auth } from "../../firebase";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

export default function Topbar({ setSidebarOpen }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <header className="relative flex items-center justify-between border-b border-white/10 bg-[#08080A]/90 px-3 sm:px-4 lg:px-6 py-4 backdrop-blur-xl">

      {/* glow line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F28C18]/40 to-transparent" />

      {/* LEFT SECTION */}
      <div className="flex items-center gap-3">

        {/* 🔥 Mobile Menu Button */}
        <button
          onClick={() => setSidebarOpen(true)}
          className="lg:hidden text-white text-2xl"
        >
          ☰
        </button>

        <div>
          <p className="text-xs uppercase tracking-[0.35em] text-zinc-500">
            Dashboard
          </p>
          <h1 className="mt-1 text-lg sm:text-xl font-black text-white">
            Overview Panel
          </h1>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <button
        onClick={handleLogout}
        className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 px-3 sm:px-5 py-2 text-xs sm:text-sm font-black uppercase tracking-[0.25em] text-zinc-200 transition hover:border-[#F28C18]/40 hover:text-[#F28C18]"
      >
        <span className="relative z-10">Logout</span>
        <span className="absolute inset-0 opacity-0 transition group-hover:opacity-100 bg-[#F28C18]/10" />
      </button>
    </header>
  );
}